export default __webpack_public_path__ + "static/media/icon-gb.9d8ab81e.svg";